// Estem Sürücü Kursu aylık kayıt döngüsü: yeni dönem her ayın 10'unda başlar,
// online kayıt için son gün ayın 8'idir. 8 ile 10 arası (8. ve 9. günler)
// online sistem değerlendirme/hazırlık aşamasındadır — bu pencerede sınırlı
// kontenjan mesajı gösterip müşteriyi telefonla da yönlendiriyoruz.
export function isLimitedQuotaWindow() {
  const day = new Date().getDate();
  return day === 8 || day === 9;
}

export const SUPPORT_PHONE = "0262 646 3 646";
export const SUPPORT_PHONE_TEL = "+902626463646";
